// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type MaterialZwischenListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetMaterialtransporteZwischenListe(): (
  taetigkeitsberichtId: string,
  fuhrparkeintragId: string
) => Promise<MaterialZwischenListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (taetigkeitsberichtId, fuhrparkeintragId) =>
      (await getAPI()).materialtransporte.getMaterialtransporteZwischenListe({
        taetigkeitsberichtId,
        fuhrparkeintragId,
      }),
    [getAPI]
  );
}
